import React, { ComponentProps, memo, ReactNode, useMemo } from 'react';

import { Loading, Pagination } from 'components';
import { Body, Header } from './components';

import * as Styles from './styles';
import { Flex } from '@chakra-ui/layout';

type PaginationProps = ComponentProps<typeof Pagination>;

export interface TableProps {
  headers: string[];
  /** Is array of grid template column, but if it is `number` be in `fr` */
  sizes: (string | number)[];
  /** Is headquarters of `ReactNode` `ReactNode` */
  rows: ReactNode[][];
  row: number[];
  path?: string | undefined;
  // row: ReactNode[];
  loading?: boolean;
  loadingText?: string;
  /** if `true`, show loading only in the table body, if is `false`, change the table by loading */
  fullLoading?: boolean;
  pagination?: PaginationProps;
  locations?: string[];
}

const TableComponent: React.FC<TableProps> = ({
  sizes: sizesParam,
  headers,
  rows,
  row,
  path,
  loading,
  locations,
  fullLoading = true,
  loadingText = 'Carregando dados',
  pagination,
}) => {
  const sizes = useMemo(() => {
    let value = '';

    sizesParam.forEach((size, index) => {
      let newSize = index === 0 ? '' : ' ';

      if (typeof size === 'number') {
        newSize += `${size}fr`;
      } else {
        newSize += `${size}`;
      }

      value += newSize;
    });

    return value;
  }, [sizesParam]);

  if (loading && fullLoading) {
    return (
      <Flex width="100%" justifyContent="center">
        <Loading text={loadingText} />
      </Flex>
    );
  }

  return (
    <Styles.Container>
      <Header headers={headers} sizes={sizes} />

      {loading && !fullLoading ? (
        <Flex width="100%" marginTop="1rem" justifyContent="center">
          <Loading text={loadingText} />
        </Flex>
      ) : (
        <Body sizes={sizes} rows={rows} row={row} path={path} locations={locations} />
      )}

      {pagination && (
        <Styles.Footer>
          <Pagination {...pagination} />
        </Styles.Footer>
      )}
    </Styles.Container>
  );
};

export const TableServiceBudgetControl = memo(TableComponent);
